import { Injectable } from '@angular/core';

@Injectable()
export class Configuracion {
	//public Server = 'http://localhost:5229/';
	public Server = 'https://ws-extranet.dim.com.ar/';
	public ServerWithApiUrl = this.Server;
}
